const HEMOLIFE_LOGO = "/img/Logo-Hemolife.png";

export default function clienteLogo(user) {
  if (!user || user.cliente_id == null || !user.cliente || !user.cliente.logo) {
    return HEMOLIFE_LOGO;
  }

  const logo = String(user.cliente.logo);
  if (/^https?:\/\//i.test(logo)) {
    return logo;
  }

  const baseUrl =
    window.location.hostname.trim() === "181.57.163.54"
      ? process.env.VUE_APP_AWS_BUCKET_URL_SECOND
      : process.env.VUE_APP_AWS_BUCKET_URL;

  if (!baseUrl) {
    return HEMOLIFE_LOGO;
  }

  return `${baseUrl.replace(/\/?$/, "/")}${logo.replace(/^\/+/, "")}`;
}
